module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB1003-3207e50be3e2826033ae9bcf6f3f03a9.png";